import { render, staticRenderFns } from "./PreferenceContentTemplate.vue?vue&type=template&id=2b67d31c"
import script from "./PreferenceContentTemplate.ts?vue&type=script&lang=ts&external"
export * from "./PreferenceContentTemplate.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports